import { twMerge } from 'tailwind-merge';

const FeatureChip = (props: {
	customLabel?: string;
	customGradient?: string;
	className?: string;
}) => {
	return (
		<div
			className={twMerge(
				`w-[90px] ml-2 justify-center whitespace-nowrap text-white flex items-center px-2 py-0.5 space-x-2 rounded-sm text-xs`,
				props.className
			)}
			style={{
				background: props.customGradient ?? 'var(--alpha-program-gradient)',
			}}
		>
			{props.customLabel ?? 'ADVANCED'}
		</div>
	);
};

export default FeatureChip;
